import React from 'react';
import { HStack, Icon, useColorModeValue } from '@chakra-ui/react';
import { FaStar } from 'react-icons/fa';

/** Estrae 1–5 da `livello_N` (enum Strapi). */
export function parseLivelloToN(value) {
  if (!value || typeof value !== 'string') return 0;
  const m = /^livello_(\d)$/.exec(value);
  if (!m) return 0;
  const n = Number(m[1], 10);
  return n >= 1 && n <= 5 ? n : 0;
}

/** Cinque stelle: le prime N piene (valore enum `livello_N`). */
export function LivelloStars({ value, max = 5, boxSize = '1rem', ...rest }) {
  const full = useColorModeValue('amber.400', 'amber.300');
  const empty = useColorModeValue('gray.300', 'gray.600');
  const n = parseLivelloToN(value);
  if (!n) return null;
  return (
    <HStack
      spacing={0.5}
      display="inline-flex"
      verticalAlign="middle"
      aria-label={`Livello ${n} su ${max}`}
      {...rest}
    >
      {Array.from({ length: max }, (_, i) => (
        <Icon
          key={i}
          as={FaStar}
          boxSize={boxSize}
          color={i < n ? full : empty}
        />
      ))}
    </HStack>
  );
}
